'use client'

import { TestimonialModelFragment } from '.generated/dato'
import { Button } from 'components/Button'
import { Container } from 'components/Container'
import { Testimonial } from 'components/Testimonial'
import { Link } from 'i18n/routing'
import { useTranslations } from 'next-intl'

interface Props {
  content?: TestimonialModelFragment | null
}

export function TestimonialQuote({ content }: Props) {
  const t = useTranslations('testimonials')

  if (!content) return null

  return (
    <Container className="bg-white">
      <Testimonial
        containerClassName="py-64 grid gap-40 md:grid-cols-2 items-center"
        testimonial={content}
        quoteClassName="md:-translate-x-64"
        figureClassName="justify-self-center md:-translate-x-80"
      >
        <span className="pt-16">
          <Link
            href={{
              pathname: '/projekte/[slug]',
              params: { slug: content.caseStudy?.slug || '' },
            }}
          >
            <Button>{t('toTheProject')}</Button>
          </Link>
        </span>
      </Testimonial>
    </Container>
  )
}
